<div *ngIf="shouldBeVisible$ | async" class="row">
  <div *ngIf="hasErrors$ | async" class="col-xs-12 form-group">
    <hr />
    <label>What kind of error was made?</label>
    <div class="error-tag-row">
      <h3-autocomplete-chips
        [nasModel]="scoreStore!('error_tags')"
        [allowedValues]="output.error_tags"
        (emittedValues)="handleTagChanges($event)"
      ></h3-autocomplete-chips>
      <mat-button-toggle-group
        class="copy-error-tag-button without-checked-state"
      >
        <mat-button-toggle
          (click)="copyErrorTags()"
          matTooltip="Copy error tags"
          [disabled]="(scoreStore!.$ | async)?.error_tags?.length === 0"
        >
          <i class="glyphicon glyphicon-copy"></i>
        </mat-button-toggle>
      </mat-button-toggle-group>
    </div>
    <span class="muted">Total: {{ errorTagsCount$ | async }}</span>
  </div>

  <div class="col-xs-6">
    <ng-container *ngIf="!editable">
      <div>
        <ng-container *ngFor="let tag of (scoreStore?.$ | async)?.error_tags">
          <span class="label label-danger">{{ tag }}</span>
        </ng-container>
      </div>
      <span *ngIf="errorTagsCount$ | async" class="error-tags-total muted"
        >Total: {{ errorTagsCount$ | async }}</span
      >
    </ng-container>
    <span
      *ngIf="
        editable &&
        (scoreStore?.$ | async)?.score === false &&
        output.error_tags.length === 0
      "
      class="explanatory muted"
    >
      No reasons for error available
    </span>
  </div>

  <div class="col-xs-6 text-right">
    <div class="btn-group btn-group-sm">
      <button
        *ngIf="editable || (scoreStore?.$ | async)?.score === true"
        class="btn btn-{{
          (scoreStore?.$ | async)?.score === true ? 'success' : 'default'
        }}"
        [disabled]="!editable"
        (click)="toggleScore(true)"
      >
        <fa-icon [icon]="faThumbsUp"></fa-icon>
      </button>
      <button
        *ngIf="editable || (scoreStore?.$ | async)?.score === false"
        class="btn btn-{{
          (scoreStore?.$ | async)?.score === false ? 'danger' : 'default'
        }}"
        [disabled]="!editable"
        (click)="toggleScore(false)"
      >
        <fa-icon [icon]="faThumbsDown"></fa-icon>
      </button>
    </div>
  </div>
</div>
